import React from 'react';
import { inject, observer } from 'mobx-react';
import { AuthStore, RoutingStore } from 'stores';
import { useTranslation } from 'react-i18next';
import { SnackBarContext, TextField } from 'components';
import { FormControl, FormLabel, Autocomplete } from '@mui/material';
import { Company, Course, Program } from 'models';


export interface ICompanySelectProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
  content:       Course | Program,
}

export const CompanySelect = inject('authStore', 'routingStore')(observer((props: ICompanySelectProps): JSX.Element => {
  const { authStore, routingStore, content } = props;
  const { t }     = useTranslation();
  const { toast } = React.useContext(SnackBarContext);

  const [companies,  setCompanies]  = React.useState<Company[]>([]);
  const [selection,  setSelection]  = React.useState<Company[]>([]);
  const [inputValue, setInputValue] = React.useState<string>('');

  React.useEffect(() => {
    content?.loadCompanyOptions().then(c => setCompanies(c));
  }, [content]);
  React.useEffect(() => {
    content?.loadCompanyWhitelist().then(c => setSelection(c));
  }, [content]);


  return (
    <FormControl fullWidth>
      <FormLabel>{t('limit_access_company')}</FormLabel>
      <Autocomplete
        multiple
        limitTags            = {4}
        id                   = 'company_select'
        disabled             = {!companies || !companies.length}
        options              = {companies as readonly Company[]}
        isOptionEqualToValue = {(option: Company, value: Company) => option.id === value.id}
        getOptionLabel       = {(option) => option.title}
        value                = {selection}
        inputValue           = {inputValue}
        noOptionsText        = {t('no_courses_found')}
        onClose              = {() => setInputValue('')}
        onChange             = {async (event, values, reason, details) => {
          let succ: boolean = true;
          switch(reason) {
            case 'selectOption':
              succ = await content.addCompanyToWhitelist(details.option.id);
              if(succ) setSelection([...selection, details.option]);
              break;
            case 'removeOption':
              succ = await content.removeCompanyFromWhitelist(details.option.id);
              if(succ) setSelection(selection.filter(s => s.id !== details.option.id));
              break;
            case 'clear':
              for(const c of selection)
                succ = await content.removeCompanyFromWhitelist(c.id);
              setSelection([]);
              break;
            
          }
          if(!succ) toast(t('failed_whitelist_update'), 'error');
        }}
        onInputChange  = {(event, value, reason) => {
          if (reason === 'reset') return;
          setInputValue(value);
        }}
        renderInput = {(params) => (
          <TextField
            {...params}
            variant     = 'outlined'
            placeholder = {t('search_for_company')}
            hiddenLabel
          />
        )}
      />
    </FormControl>
  );
}));